import React, { useRef, useEffect, FC } from 'react';
import { Tree, TreeDataProps } from './Tree';

import { GetIcon } from './util';
import classNames from 'classnames';
import { CaretDownOutlined, CheckOutlined } from '@easyv/react-icons';

export interface TreeNodeProp {
  isLastNode: boolean;
  depth: number;
  dataSource: TreeDataProps;
  selectedKey?: string;
  onSelect?: (value: TreeDataProps) => void;
  setCollapsed: (value: TreeDataProps) => void;
}

export type HoverState = 'above' | 'below' | 'inside' | 'none';

export const TreeNode: FC<TreeNodeProp> = ({
  isLastNode,
  depth,
  dataSource,
  selectedKey,
  onSelect,
  setCollapsed,
}) => {
  const isCollapsed = dataSource.collapsed;
  const treeNodeRef = useRef<HTMLDivElement | null>(null);

  const treeNode = (
    <div
      className={classNames(
        `group pr-2 h-7 flex leading-4`,
        // selectedItems.includes(dataSource)
        dataSource.key === selectedKey
          ? 'bg-FFFFFF0F cursor-default'
          : 'cursor-pointer hover:bg-FFFFFF0F',
      )}
      style={{ paddingLeft: `${16 * depth + 8}px` }}
    >
      {dataSource.children.length > 0 ? (
        <div className='w-4 flex items-center justify-center h-full'>
          <div
            className={classNames(
              'cursor-pointer flex items-center relative hierarchy-node-line-button-up',
              isCollapsed && !isLastNode && 'hierarchy-node-line-button-down',
            )}
            onClick={(e) => {
              e.stopPropagation();
              setCollapsed(dataSource);
            }}
          >
            <CaretDownOutlined
              size={9}
              className={classNames(
                'transform transition-transform duration-300 text-xs text-FFFFFF3D  items-center justify-center',
                !isCollapsed ? '' : '-rotate-90',
              )}
            />
          </div>
        </div>
      ) : (
        <div className='w-4 h-full relative'>
          <div
            className={classNames(
              isLastNode ? 'hierarchy-node-line-last' : 'hierarchy-node-line-middle',
            )}
          ></div>
        </div>
      )}
      <div className='flex items-center gap-x-1 flex-1 relative truncate'>
        <div className='flex items-center justify-center w-4 h-4 shrink-0  text-white'>
          {GetIcon(dataSource.type)}
        </div>
        <div className={classNames('flex-1 cursor-pointer truncate text-white')}>
          <span>{dataSource.title}</span>
        </div>
        {dataSource.key === selectedKey && <CheckOutlined style={{ color: '#B4B7C1' }} size={14} />}
      </div>
    </div>
  );

  useEffect(() => {
    if (treeNodeRef.current) {
      treeNodeRef.current.scrollIntoView({
        behavior: 'auto',
        block: 'nearest',
      });
    }
  }, [dataSource]);

  return dataSource?.children?.length ? (
    // data-id 和 data-offsettop仅用于选中时世界大纲自动定位到实体
    <div data-id={dataSource.id}>
      <div
        className={classNames('relative')}
        onClick={(e) => {
          e.stopPropagation();
          onSelect?.(dataSource);
        }}
        ref={dataSource.key === selectedKey ? treeNodeRef : null}
      >
        {treeNode}
      </div>
      {isCollapsed ? null : (
        <>
          <div className='relative'>
            <Tree
              dataSource={dataSource.children}
              depth={++depth}
              onSelect={onSelect}
              setCollapsed={setCollapsed}
            />
          </div>
        </>
      )}
    </div>
  ) : (
    <div
      className={classNames('relative')}
      data-id={dataSource.id}
      onClick={(e) => {
        e.stopPropagation();
        onSelect?.(dataSource);
      }}
      ref={dataSource.key === selectedKey ? treeNodeRef : null}
    >
      {treeNode}
    </div>
  );
};
